import { render } from "./FTPNavigatorTask.vue?vue&type=template&id=135451f4&scoped=true"
import script from "./FTPNavigatorTask.vue?vue&type=script&lang=js"
export * from "./FTPNavigatorTask.vue?vue&type=script&lang=js"

import "./FTPNavigatorTask.vue?vue&type=style&index=0&id=135451f4&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135451f4"]])

export default __exports__